//* 화환 단가표 페이지 전용 atom

import { atom } from 'recoil';

import { QueryStatus } from 'react-query';

import { PriceTableResponse } from './priceTable.interface';

export const flowerPriceTableStatusAtom = atom<QueryStatus>({
  key: 'flowerPriceTableStatusAtom',
  default: 'idle',
});

export const flowerPriceTableDataAtom = atom<PriceTableResponse | null>({
  key: 'flowerPriceTableDataAtom',
  default: null,
});
